<template>
  <el-dialog
    class="createTaskDialog"
    width="850px"
    :title="title"
    :visible.sync="dialogVisible"
    @close="cancelDialog"
    @opened="OpenDialog"
    append-to-body
    center
  >
    <el-scrollbar
      wrap-class="list"
      view-style="font-weight: bold;"
      view-class="view-box"
      :native="false"
    >
      <el-form
        :model="createTaskMeg"
        ref="ruleForm"
        :rules="rules"
        class="createTaskForm demo_ruleForm"
        label-position="left"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" label-width="100px" prop="taskName">
              <el-input
                placeholder="请描述您的问题"
                v-model="createTaskMeg.taskName"
                clearable
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="内容描述" label-width="100px">
              <wangeditor ref="editorTxt" v-model="createTaskMeg.content"></wangeditor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="截图" label-width="100px">
              <el-button @click="captureStart" type="primary" size="mini">截图</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截图设置" label-width="100px">
              <el-checkbox v-model="createTaskMeg.hideWindow">隐藏当前窗口</el-checkbox>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="添加附件" label-width="100px">
              <el-upload
                class="upload-demo"
                action="http://localhost:8080"
                :limit="5"
                :on-exceed="exceedUpload"
                :auto-upload="true"
                ref="upload"
                :before-upload="beforeUpload "
                :on-change="handleChange"
                :file-list="FileList"
              >
                <el-button type="primary" size="mini">添加附件</el-button>
              </el-upload>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </el-scrollbar>
    <div slot="footer" class="dialog-footer">
      <el-row>
        <el-col :span="24" style="text-align:center">
          <el-button @click="dialogVisible=false" size="mini">取 消</el-button>
          <el-button @click="reportStart" type="primary" size="mini">修改</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import cap from "@/capturn/capturnwrapper.js";
import { getToken } from "../../../util/auth";
import wangeditor from "@/components/common/editor.vue";
import {
  EditTask,
  GetSysUserByCode,
  workflowCreate,
  AddAssignTask,
  AddAssignFileTask,
  GetCompanyAllGeneralSelTree
} from "@/api/modules/basicData/task";
import { GetFuncRoomByCompanyId } from "@/api/modules/basicData/organization";
const cookieUser = getToken();
export default {
  name: "CreateTask",
  props: {
    noticePersons: [],
    taskTypeName: "",
    taskDetail:{},
  },
  components: {
    wangeditor,
  },
  data() {
    var checknum = (rule, value, callback) => {
      value = this.trim(value);
      if (!value) {
        callback(new Error("请描述您的问题"));
        this.time("ruleForm", "taskName");
      } else {
        callback();
      }
    };
    return {
      title: "修改任务",
      dialogVisible:false,
      createTaskMeg: {
        taskName: "", //任务名称
        isEvaluter: true, // 是否是评价人
        resolved: false, // 是否已解决
        content: "", //内容描述
        funcRoom: null, //功能间信息
        man: "",
        proposer: null, // 报告人
        taskLevelSel: "1",
        focusLevelSel: "3",
        hideWindow: true, // 是否隐藏当前窗口
        taskType: null,
        solution: "",
        linkUser: "", //联系人
        ReceiveUser: {},
        ReceiveUserName: "",
        excuterUser: {}, // 接收人
        DoneDevices: [], //设备
        reportDept: null, // 选择的组织。
        taskGroup: null,
        mech: {
          // 机构信息
          ID: this.companyId,
          NAME: this.companyName
        },
        planStartDT: new Date(),
        planEndDT: new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
        firstRemindTime: "0",
        overdueTime: "0",
        firstRemindTimeUnit: "h",
        overdueTimeUnit: "h"
      },
      rules: {
        taskName: [
          {
            required: true,
            // message: '请描述您的问题',
            validator: checknum,
            trigger: "blur"
          },
          {
            min: 2,
            max: 50,
            message: "长度在 2 - 50 个字符以内",
            trigger: "blur"
          }
        ],
      },
      FileList: [],
    };
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      ServerCenterIds: state => state.task.ServerCenterIds,
      contactId: state => state.user.ContactID,
      realName: state => state.task.realName,
      departmentId: state => state.user.departmentId,
      departmentName: state => state.user.departmentName,
      companyId: state => state.user.companyId,
      companyName: state => state.user.companyName
    }),
  },
  mounted() {

  },
  created() {
    cap.Init(this); //初始化截图插件。
  },
  watch: {
    // dialogVisible(val) {
    //   if (val) {
    //     this.initCreatTaskInfo();
    //   }
    // }
  },
  methods: {
    OpenDialog(){
      this.createTaskMeg.taskName = this.taskDetail.TASKNAME ; // 标题
      this.createTaskMeg.content = this.taskDetail.CONTENT ; // 报修内容
      console.log('详情',this.taskDetail.CONTENT);
      this.setAppendContent(this.taskDetail.CONTENT)
      // this.$refs.editorTxt.setContent();
      this.dialogVisible=true;
    },
    initCreatTaskInfo() {
      // 初始化创建任务的信息
      this.createTaskMeg.repairTime = [];
      this.createTaskMeg.repairTime.push(new Date());
      this.createTaskMeg.repairTime.push(
        new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
      );
      // 提醒
      this.createTaskMeg.planStartDT = new Date();
      this.createTaskMeg.planEndDT = new Date().setTime(
        new Date().getTime() + 3600 * 1000 * 2
      );
      this.createTaskMeg.firstRemindTime = 0;
      this.createTaskMeg.overdueTime = 0;
      this.createTaskMeg.firstRemindTimeUnit = "h";
      this.createTaskMeg.overdueTimeUnit = "h";

      this.createTaskMeg.taskLevelSel = "1";
      this.createTaskMeg.focusLevelSel = "3";
      this.createTaskMeg.taskName = "";
      this.createTaskMeg.resolved = false;
      this.createTaskMeg.content = "";
      this.createTaskMeg.hideWindow = true;
      this.FileList = [];
    },
    captureStart() {
      // 截图开始
      cap.StartCapture(this.createTaskMeg.hideWindow, this);
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.warning("上传单个文件大小不能超过 1G!");
        return;
      }
      this.FileList.push(file);
      return false;
    },
    exceedUpload(file, fileList) {
      this.$message.warning("最多上传五个文件");
    },
    handleChange(file, fileList) {
      console.log(this.FileList);
    },
    setAppendContent(imgHtml) {
      this.$refs.editorTxt.setAppendContent(imgHtml);
    },
    facilityGetValue(value) {
      // 选择设备
      console.log(value);
    },
    Guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    reportStart() {
      // 开始上报准备
      var editData = {}; //上报的数据用这个
      if (!this.createTaskMeg.taskName) {
        this.$message.warning("请填写标题!");
        return false;
      }
      if (!this.createTaskMeg.taskName.length > 50) {
        this.$message.warning("标题限制字数为50字!");
        return false;
      }
      var personInfo = {
              ID: this.userId,
              NAME: this.realName,
              DEPTID: this.departmentId,
              DEPTNAME: this.departmentName,
              COMPANYID: this.companyId,
              COMPANYNAME: this.companyName
            };
      editData=this.taskDetail;

      editData.TASKNAME = this.createTaskMeg.taskName; // 标题
      editData.CONTENT = this.createTaskMeg.content; // 报修内容
      // var formData = new FormData();
      if (this.FileList.length > 0) {
        for (var i = 0; i < this.FileList.length; i++) {
          formData.append(i.toString(), this.FileList[i]);
        }
      }
        // formData.append("TaskInfo", JSON.stringify(editData));
        // formData.append("Person", JSON.stringify(personInfo));

        let formData = {
          TaskInfo:editData,
          Person:personInfo
        }
        EditTask(formData)
          .then(res => {
            if (res == 1) {
              this.$message({
                message: "报修成功!",
                type: "success"
              });
              this.initCreatTaskInfo();
              this.dialogVisible = false;
            } else {
              this.$message.error("报修失败");
            }
          })
          .catch(err => {
            this.$message.error("报修失败" + err);
            console.error(err);
          });
    },
    cancelDialog() {
      this.initCreatTaskInfo();
    },

  }
};
</script>

<style lang="less" scoped>
.isActiveClass {
  transform: rotate(90deg);
}
.createTaskDialog {
  .el_dialog__footer {
    padding: 0px 10px 10px;
  }
  .el-dialog__body {
    padding: 0px 20px;
  }
  .el-dialog__header {
    text-align: left;
    padding: 10px 10px 10px;
  }
  .el-col {
    margin-top: 0px;
    // padding-right: 20px;
    padding-left: 10px;
  }
  height: 100%; // overflow: hidden;
  .el-form {
    text-align: left;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .rightPadding {
    box-sizing: border-box;
    // padding-right: 20px;
  }
  .selectInput {
    display: inline-block;
  }
  .workFlow {
    margin-right: 20px;
    color: red;
    font-size: large;
  }
  .list {
    max-height: 600px;
  }
  .createTaskForm {
    margin-bottom: 20px;
    width: 99%;
  }
}
</style>
